var _style, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _path13, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUllrLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 557 486",
    style: {
      enableBackground: "new 0 0 557 486"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;fill-opacity:0;stroke:#231F20;stroke-width:7;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:none;stroke:#231F20;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{fill:#231F20;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#231F20;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.9,238.9c0,122.4-99.3,221.7-221.7,221.7S61.5,361.4,61.5,238.9c0-37.7,9.4-73.2,26-104.3 c37.3-69.9,111-117.4,195.7-117.4c91.8,0,170.6,55.8,204.3,135.4C498.7,179.2,504.9,208.3,504.9,238.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.5014,
    y1: 430.3702,
    x2: 114.5014,
    y2: 430.3702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1054,
    style: {
      stopColor: "#707174"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    style: {
      stopColor: "#747578"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2583,
    style: {
      stopColor: "#808184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    style: {
      stopColor: "#949597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4117,
    style: {
      stopColor: "#B0B1B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4877,
    style: {
      stopColor: "#D4D4D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5622,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.5,430.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.5,430.4"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347.1,264.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341.3,319.6"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321.9,243.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M284.4,410.1c-1.3,0-2.3,1.3-3.2,2.7c-6.1,10-3,25.6-2.3,25.6c0.6,0,0.1-9.5,0.7-9.5c0.9,0,1.8,19.9,2.9,19.9 c1.1,0,1.5-19.6,3.4-19.7c0.8,0,2.4,3,2.3,4.1c-3.1,22.8,3.2-5.9,2.5-11.8C290.1,416.3,287.3,410.1,284.4,410.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.2,402.6c0.3,0,0.8,0.1,1.1,0.5c0.8,1-0.4,3.4-2,4.7c-0.9,0.8-2.8,1.9-3.8,1.2c-0.5-0.4-0.6-1.1-0.7-1.2 C280.4,405.4,283.6,402.3,286.2,402.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.6,406c0.3,0,0.8,0.1,1.1,0.5c0.8,1-0.4,3.4-2,4.7c-0.9,0.8-2.8,1.9-3.8,1.2c-0.5-0.4-0.6-1.1-0.7-1.2 C280.8,408.9,284,405.8,286.6,406z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286.5,404c-0.3-1-1-0.7-0.6-0.9c0.6-0.3,0.6,0,0.7,0c0.3,0.1,0.5,0.5,0.5,0.6c0.2,0.4,0,0.8-0.1,1.1 c-0.2,0.6-0.5,0.9-0.6,1.1c-0.6,0.7-3,2.1-2.6,1.6C285.5,405.3,286.8,404.9,286.5,404z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.1,407.4c-0.3-1-1-0.7-0.6-0.9c0.6-0.3,0.6,0,0.7,0c0.3,0.1,0.5,0.5,0.5,0.6c0.2,0.4,0,0.8-0.1,1.1 c-0.2,0.6-0.5,0.9-0.6,1.1c-0.6,0.7-3,2.1-2.6,1.6C286,408.7,287.4,408.3,287.1,407.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M218.5,178.3c0,7-6.1,12.7-17.1,12.7c-10.9,0-18.8-5.9-18.8-12.9s7.9-12.5,18.8-12.5 C212.4,165.6,218.5,171.3,218.5,178.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M197.2,92.6c-2.1-3-5.6-5-9.5-5c-6.2,0-11.6,5.3-11.5,11.1c8.1,47.5,6.5,78.8,6.5,78.8l35.8,1.4v-29.3 C218.1,130.4,208.2,109.8,197.2,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.2,86.3c3.6,0,6.7,1.6,8.8,4.2c-14.1-21.6-29.6-37.4-29.6-37.4c4.1,15.6,7.2,30.3,9.6,43.7 C176.3,91,181.2,86.3,187.2,86.3z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M384.7,184.7c-1.8,5.7-8.9,10-18.3,10c-9.5,0-15.3-4.3-16.7-10h-0.1v41.6c0,60.7-26.1,87.5-66.8,87.5 c-36.6,0-63.9-26.1-63.9-87.5v-41.6h-0.6c-1.4,5.7-7.3,10-16.7,10c-9.4,0-16.5-4.3-18.3-10H183v103.2c0,12.4,0.9,23.6,2.6,33.8 c2.4-9.2,9.7-12,10.3-11.9c0.8,0.2-7.3,17.8,1.6,37.7c3,6.6,7,13.6,9.9,17.9c-1.9-5.1-2.9-9.2-3.3-11.2c-4-17.8,0.8-32.6,1.4-32.6 c0.6,0-5,18.6,3.6,37.1c3.7,8,10.2,16.4,12.4,19.2c3.7,4.7,6.1,7.2,8.1,9.5c-2.8-6.3-4-11.8-4.5-14.1c-4-17.8,0.8-32.6,1.4-32.6 c0.6,0-5,18.6,3.6,37.1c2.2,4.7,5.4,9.6,8.1,13.4c-4.7-11.9-2.8-22.6-2.4-22.6c0.4,0,2.3,11.4,10.9,23.5c2.7,3.8,6.6,7.2,9.3,9.4 c-6.3-12.2-7.1-22.9-6.7-23.1c0.5-0.2,6.2,13,19.3,26.1c0.2,0,0.4,0,0.6,0c-0.5-1.2-0.8-2.2-1.1-3c-0.1-0.3-1.2-3.3-3.5-9.5 c-3.4-9.1,3.7,8,5.8,12.6c0.1,0,0.2,0,0.3,0c-1.2-4.5-2.3-5.5-1.6-5.6c0.8-0.2,1-3.9,6.6,5.8c0,0.1,0.1,0.1,0.1,0.2 c0.2,0,0.4,0,0.5,0c-0.5-2.2-2.5-7.8,0.3-4.4c1.4,1.7,2.7,3.2,3.8,4.5c0.4,0,0.8,0,1.2,0c2.3,0,4.5-0.1,6.7-0.2 c1.3-1.5,3-3.4,4.9-5.8c4-4.9-1.8,8.9,0.9,4.2c5.6-9.7,5.8-5.9,6.6-5.8c0.7,0.1-0.6,1.2-1.9,6.5c0,0,0.1,0,0.1,0 c1.2-2.2,9.9-23.3,6.2-13.5c-2.3,6.2-3.5,9.2-3.5,9.5c-0.3,0.9-0.7,2.1-1.4,3.7c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0,0 c13.8-13.3,19.7-27.1,20.2-26.9c0.4,0.1-0.4,10.9-6.7,23.1c2.7-2.3,6.6-5.7,9.3-9.4c8.5-12.1,10.4-23.5,10.9-23.5 c0.4,0,2.3,10.7-2.4,22.6c2.7-3.8,5.9-8.6,8.1-13.4c8.6-18.5,3-37,3.6-37.1c0.5,0,5.3,14.7,1.4,32.6c-0.5,2.3-1.7,7.8-4.5,14.1 c2-2.4,4.4-4.8,8.1-9.5c2.2-2.8,8.7-11.3,12.4-19.2c8.6-18.5,3-37,3.6-37.1c0.5,0,5.3,14.7,1.4,32.6c-0.4,2-1.4,6.2-3.3,11.2 c2.9-4.4,7-11.3,9.9-17.9c8.9-19.9,0.8-37.5,1.6-37.7c0.5-0.1,6.2,2.1,9.2,8.9c1.5-9.5,2.3-19.7,2.3-30.9V184.7H384.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M349.3,178.3c0,7,6.1,12.7,17.1,12.7c10.9,0,18.8-5.9,18.8-12.9s-7.9-12.5-18.8-12.5 C355.4,165.6,349.3,171.3,349.3,178.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M380.7,86.3c6,0,10.9,4.7,11.3,10.6c2.3-13.4,5.4-28.1,9.6-43.7c0,0-15.5,15.8-29.6,37.4 C374,88,377.1,86.3,380.7,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M391.6,98.6c0-5.8-5.3-11.1-11.5-11.1c-4,0-7.5,2-9.5,5c-11,17.2-20.8,37.8-21.3,57v29.3l35.8-1.4 C385.1,177.5,383.6,146.1,391.6,98.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUllrLogoSmall);
export default __webpack_public_path__ + "static/media/ULLRLogo-small.1c4f00428d485c8ab97998c06633ca77.svg";
export { ForwardRef as ReactComponent };